import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { useEffect, useMemo, useState } from "react";
import "../../assets/css/views/executionManagement/executionManagement.css";
import {
  Button,
  Card,
  ContextualMenu,
  DatePicker,
  DateRange,
  FilePicker,
  Group,
  IconPencil,
  IconTrash,
  Modal,
  MomentObj,
  OptionInterface,
  Select,
  SelectOption,
  Table,
  TableColumnWidth,
  TableColumns,
  TableData,
  TablePagination,
  TablePreferences,
  TextBox,
} from "@veneer/core";
import moment, { Moment } from "moment";
import UsersManagementService from "../../services/userManagementApi/usersManagement.service";
import { IGetCountriesListDto } from "../../models/dto/userManagementApi/IGetCountriesListDto";
import appointmentService from "../../services/agendaApi/appointment.service";
import visualExecutionService from "../../services/agendaApi/visualExecution.service";
import { ICampaignsDto } from "../../models/dto/agendaApi/ICampaignsDto";
import { ISubretailListDto } from "../../models/dto/agendaApi/ISubretailListDto";
import { IUpdateCampaignsIn } from "../../models/input/agendaApi/IUpdateCampaignsIn";
import { ICreateCampaignsIn } from "../../models/input/agendaApi/ICreateCampaignsIn";
import productService from "../../services/generalApi/product.service";
import ImageService from "../../services/generalApi/image.service";
import { ModalInformational } from "../SellOut/SellOutComponent/ModalInformational";
import { ModalQuestion } from "../SellOut/SellOutComponent/ModalQuestion";
import { IDeleteCampaignsIn } from "../../models/input/agendaApi/IDeleteCampaignsIn";

export default function ExecutionManagement() {
  type SelectValue = number | string | boolean;
  const [t] = useTranslation("global");
  const languageID: any = useSelector((state: RootState) => state.languageId);
  const [tableData, setTableData] = useState<TableData[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [valueName, setValueName] = useState<string>("");
  const [valueNameEdit, setValueNameEdit] = useState<string | undefined>("");
  const [isNameValid, setIsNameValid] = useState<boolean>(true);
  const [isNameValidEdit, setIsNameValidEdit] = useState<boolean>(true);
  const [isButtonValid, setIsButtonValid] = useState<boolean>(true);
  const [isButtonValidEdit, setIsButtonValidEdit] = useState<boolean>(true);
  const [isDisabledCountry, setIsDisabledCountry] = useState<boolean>(true);
  const [optionsCountry, setOptionsCountry] = useState<SelectOption[]>([]);
  const [optionsSubRetail, setOptionsSubRetail] = useState<SelectOption[]>([]);
  const [optionsSubRetailCopy, setOptionsSubRetailCopy] = useState<
    SelectOption[]
  >([]);
  const [valueCountry, setValueCountry] = useState<SelectValue[]>([]);
  const [valueSubRetail, setValueSubRetail] = useState<SelectValue[]>([]);
  const [openModalCreateExecution, setOpenModalCreateExecution] =
    useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [editModal, setEditModal] = useState<boolean>(false);
  const [openMessageError, setOpenMessageError] = useState(false);
  const [openMessageUpdate, setOpenMessageUpdate] = useState(false);
  const [openMessageDeleteOk, setOpenMessageDeleteOk] = useState(false);
  const [openMessageCreateOk, setOpenMessageCreateOk] = useState(false);
  const [valueCampaignsStartDate, setValueCampaignsStartDate] =
    useState<Moment>();
  const [valueCampaignsEndDate, setValueCampaignsEndDate] = useState<Moment>();
  const [valueCampaignsStartDateEdit, setValueCampaignsStartDateEdit] =
    useState<Moment>();
  const [valueCampaignsEndDateEdit, setValueCampaignsEndDateEdit] =
    useState<Moment>();
  const [disabledDatePickerEnd, setDisabledDatePickerEnd] =
    useState<boolean>(true);
  const [valueSubRetailEdit, setValueSubRetailEdit] = useState<SelectValue[]>(
    []
  );
  var tableDataArray: ICampaignsDto[];

  useEffect(() => {
    getExecution();
    getCountriesList();
  }, [languageID]);

  const initialFormState: ICreateCampaignsIn = {
    nameCampaign: "",
    startDate: "",
    endDate: "",
    url: "",
    userId: 0,
    countryIDs: "",
    retailIDs: "",
  };

  const initialValidationState = {
    Name: false,
    StartDate: false,
    EndDate: false,
    Url: false,
  };

  const [formExecutionManagement, setFormExecutionManagement] =
    useState<ICreateCampaignsIn>(initialFormState);
  const [handleValidate, setHandleValidate] = useState(initialValidationState);

  const [formExecutionManagementEdit, setFormExecutionManagementEdit] =
    useState<IUpdateCampaignsIn>({
      UserID: 0,
      CampaignId: 0,
      NameCampaign: "",
      StartDate: "",
      EndDate: "",
      SubRetailIdOld: "",
      SubRetailId: "",
      CountryId: 0
    });
  
  const [formExecutionManagementDelete, setFormExecutionManagementDelete] =
    useState<IDeleteCampaignsIn>({
      UserID: 0,
      CampaignId: 0,
      CountryId: 0,
    });

  const [handleValidateEdit, setHandleValidateEdit] = useState({
    Name: true,
    StartDate: true,
    EndDate: true,
  });

  const memoizedHandleValidate = useMemo(
    () => handleValidate,
    [handleValidate]
  );

  const memoizedHandleValidateEdit = useMemo(
    () => handleValidateEdit,
    [handleValidateEdit]
  );

  useEffect(() => {
    const allTrue = Object.values(memoizedHandleValidate).every(
      (value) => value === true
    );

    if (allTrue) {
      setIsButtonValid(false);
    } else {
      setIsButtonValid(true);
    }
  }, [memoizedHandleValidate]);

  useEffect(() => {
    const allTrue = Object.values(memoizedHandleValidateEdit).every(
      (value) => value === true
    );

    if (allTrue) {
      setIsButtonValidEdit(false);
    } else {
      setIsButtonValidEdit(true);
    }
  }, [memoizedHandleValidateEdit]);

  //Configuracion de la tabla
  const columnsWidth: TableColumnWidth[] = [
    { columnId: "execution", width: "15%" },
    { columnId: "country", width: "15%" },
    { columnId: "subRetail", width: "15%" },
    { columnId: "startDate", width: "15%" },
    { columnId: "endDate", width: "15%" },
    { columnId: "url", width: "25%" },
  ];

  const tablePreferences: TablePreferences = {
    width: columnsWidth,
  };

  const columns: TableColumns[] = [
    { id: "execution", label: t("header.execution") },
    { id: "country", label: t("header.country") },
    { id: "subRetail", label: t("header.subRetail") },
    { id: "startDate", label: t("header.stardDate") },
    { id: "endDate", label: t("header.endDate") },
    { id: "url", label: "Url" },
  ];

  const pagedData = tableData.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLElement>,
    option: OptionInterface<number>
  ) => {
    setPageSize(option.value);
  };

  const paginationProps: TablePagination = {
    currentPage,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange,
    pageSize,
    totalItems: tableData.length,
  };

  const handleActionRowConfig = (
    e: React.SyntheticEvent,
    option?: OptionInterface,
    countryId?: string
  ) => {
    if (option) {
      if (option.label === t("header.edit")) {
        ChargeInfoForEdit(Number(option.value), countryId);
        setEditModal(true);
      } else if (option.label === t("header.delete")) {
        setDeleteModal(true);
        setFormExecutionManagementDelete((prevState) => ({
          ...prevState,
          CampaignId: Number(option.value),
          CountryId: Number(countryId),
        }));
      }
    }
  };

  const ChargeInfoForEdit = (value: number, countryId: string | undefined) => {
    let item = tableDataArray.find((x) => x.executionID === value && x.countryId === countryId);
    
    getSubretail(String(item?.countryId));

    setFormExecutionManagementEdit((prevState) => ({
      ...prevState,
      NameCampaign: item?.executionName ? item.executionName : "",
      StartDate: item?.startDate ? FormatDate(item?.startDate) : "",
      EndDate: item?.endDate ? FormatDate(item?.endDate) : "",
      CampaignId: item?.executionID ? item?.executionID : 0,
      SubRetailIdOld: item?.subRetailId ? String(item?.subRetailId) : "",
      CountryId: item?.countryId ? Number(item?.countryId) : 0,
    }));

    setValueNameEdit(item?.executionName);
    setValueCampaignsStartDateEdit(moment(item?.startDate));
    setValueCampaignsEndDateEdit(moment(item?.endDate));
    const subRetailId: string | undefined = item?.subRetailId;

    if (subRetailId) {
      const subRetailIdsArray = subRetailId.split(",").map(Number);
      setValueSubRetailEdit(subRetailIdsArray);
    } else {
      setValueSubRetailEdit([]);
    }
  };

  const getExecution = () => {
    setLoading(true);
    visualExecutionService.getCampaigns().then((result: ICampaignsDto[]) => {
      tableDataArray = result;
      fillData(result);
    });
  };

  const getCountriesList = () => {
    UsersManagementService.getCountriesList().then(
      (result: IGetCountriesListDto[]) => {
        const updatedOptions = result.map((item) => ({
          value: item.contryId,
          label: item.countryName,
        }));
        setOptionsCountry(updatedOptions);
      }
    );
  };

  const getSubretail = (countryIDs: string) => {
    appointmentService.getSubretailByCountries(countryIDs).then((r: any) => {
      fillDataSubretail(r);
    });
  };

  const downlodPdf = async (url: string | undefined) => {
    if (url !== undefined) {
      const r = await ImageService.getFilePath(url);

      const link = document.createElement("a");
      link.href = r;
      link.target = "_blank";

      link.click();

      link.remove();
    }
  };

  const fillData = (data: ICampaignsDto[]) => {
    const pagedData: TableData[] = [];

    for (let i = 0; i < data.length; i++) {
      const campaignsFileList = data[i];
      let tableData: TableData = {};

      tableData = {
        execution: campaignsFileList.executionName,
        startDate: FormatDate(campaignsFileList.startDate, "DD-MM-YYYY"),
        endDate: FormatDate(campaignsFileList.endDate, "DD-MM-YYYY"),
        url: (
          <span
            onClick={() => downlodPdf(campaignsFileList.url)}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            role="link"
            tabIndex={0}
          >
            {campaignsFileList.url}
          </span>
        ),
        country: campaignsFileList.countryName,
        subRetail: campaignsFileList.subRetailName,

        rowConfig: {
          action: (
            <ContextualMenu
              onClick={(e, option) =>
                handleActionRowConfig(e, option, campaignsFileList.countryId)
              }
              options={[
                {
                  value: campaignsFileList.executionID,
                  label: t("header.edit"),
                  icon: <IconPencil />,
                },
                {
                  value: campaignsFileList.executionID,
                  label: t("header.delete"),
                  icon: <IconTrash />,
                },
              ]}
              placement="leading"
            />
          ),
          disabled: false,
          noWrap: false,
          selected: false,
        },
      };
      pagedData.push(tableData);
    }

    setTableData(pagedData);
    setLoading(false);
  };

  const fillDataSubretail = (data: ISubretailListDto[]) => {
    const subretailData: SelectOption[] = [];

    for (let i = 0; i < data.length; i++) {
      const subretail: ISubretailListDto = data[i];
      let selectSubretailData: SelectOption;
      if (subretail.subRetailId !== 0) {
        selectSubretailData = {
          value: subretail.subRetailId,
          label: subretail.subRetailName,
        };
        subretailData.push(selectSubretailData);
      }
    }
    setOptionsSubRetail(subretailData);
    setOptionsSubRetailCopy(subretailData);
  };

  const handleOnClickOpenCreate = () => {
    setOpenModalCreateExecution(true);
    setFormExecutionManagement(initialFormState);
    setHandleValidate(initialValidationState);
    setValueName("");
    setValueCountry([]);
    setValueSubRetail([]);
    setValueCampaignsStartDate(undefined);
    setValueCampaignsEndDate(undefined);
    onClearFilePicker();
  };

  const handleOnClickCloseCreate = () => {
    setOpenModalCreateExecution(false);
  };

  const handleOnClickCloseEdit = () => {
    setEditModal(false);
  };

  const changeHandlerName = (text: string) => {
    if (text === "") {
      setValueName(text);
      setIsNameValid(true);
      setHandleValidate((prevState) => ({
        ...prevState,
        Name: false,
      }));
      setFormExecutionManagement((prevState) => ({
        ...prevState,
        nameCampaign: "",
      }));
    } else if (text !== "") {
      setValueName(text);
      setIsNameValid(false);
      setHandleValidate((prevState) => ({
        ...prevState,
        Name: true,
      }));
      setFormExecutionManagement((prevState) => ({
        ...prevState,
        nameCampaign: text,
      }));
    }
  };

  const changeHandlerNameEdit = (text: string) => {
    if (text === "") {
      setValueNameEdit(text);
      setIsNameValidEdit(true);
      setHandleValidateEdit((prevState) => ({
        ...prevState,
        Name: false,
      }));
      setFormExecutionManagementEdit((prevState) => ({
        ...prevState,
        NameCampaign: "",
      }));
    } else if (text !== "") {
      setValueNameEdit(text);
      setIsNameValidEdit(false);
      setHandleValidateEdit((prevState) => ({
        ...prevState,
        Name: true,
      }));
      setFormExecutionManagementEdit((prevState) => ({
        ...prevState,
        NameCampaign: text,
      }));
    }
  };

  const FormatDate = (date: string, format: string = "YYYY-MM-DD") => {
    let timestamp = Date.parse(date);
    if (!isNaN(timestamp)) {
      let dateTemp = new Date(date);
      let year = dateTemp.getFullYear();
      let month = (dateTemp.getMonth() + 1).toString().padStart(2, "0");
      let day = dateTemp.getDate().toString().padStart(2, "0");

      switch (format) {
        case "DD-MM-YYYY":
          return `${day}-${month}-${year}`;
        case "MM-DD-YYYY":
          return `${month}-${day}-${year}`;
        case "YYYY-MM-DD":
          return `${year}-${month}-${day}`;
        case "YYYY-DD-MM":
          return `${year}-${day}-${month}`;
        case "DD/MM/YYYY":
          return `${day}/${month}/${year}`;
        case "MM/DD/YYYY":
          return `${month}/${day}/${year}`;
        default:
          return "";
      }
    } else {
      return "";
    }
  };

  const onClearCountrySelect = (): void => {
    setValueCountry([]);
    setIsDisabledCountry(true);
    setValueSubRetail([]);
    setFormExecutionManagement((prevState) => ({
      ...prevState,
      countryIDs: "",
    }));
  };

  const onChangeCountry = (option: any): void => {
    const valueCopy = [...valueCountry];
    const isOptionSelected = valueCopy.includes(option.value);

    if (isOptionSelected) {
      const index = valueCopy.indexOf(option.value);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(option.value);
    }

    setIsDisabledCountry(false);
    setValueCountry(valueCopy);
    getSubretail(String(valueCopy));

    setFormExecutionManagement((prevState) => ({
      ...prevState,
      countryIDs: String(valueCopy),
    }));
  };

  const onChangeSubRetail = (option: any): void => {
    const valueCopy = [...valueSubRetail];
    const isOptionSelected = valueCopy.includes(option.value);

    if (isOptionSelected) {
      const index = valueCopy.indexOf(option.value);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(option.value);
    }

    setValueSubRetail(valueCopy);
    setFormExecutionManagement((prevState) => ({
      ...prevState,
      retailIDs: String(valueCopy),
    }));
  };

  const onChangeSubRetailEdit = (option: any): void => {
    const valueCopy = [...valueSubRetailEdit];
    const isOptionSelected = valueCopy.includes(option.value);

    if (isOptionSelected) {
      const index = valueCopy.indexOf(option.value);
      valueCopy.splice(index, 1);
    } else {
      valueCopy.push(option.value);
    }

    setValueSubRetailEdit(valueCopy);
 
    setFormExecutionManagementEdit((prevState) => ({
      ...prevState,
      SubRetailId: String(valueCopy),
    }));
  };

  const onClearSubRetailSelect = (): void => {
    setValueSubRetail([]);
  };

  const onClearSubRetailSelectEdit = (): void => {
    setValueSubRetailEdit([]);
    setFormExecutionManagementEdit((prevState) => ({
      ...prevState,
      SubRetailId: "",
    }));
  };

  const handleSearchSubRetail = (query: string): void => {
    const newOptions = [...optionsSubRetailCopy];

    const objetosFiltradosConValueLabel = newOptions
      .map((objeto) => ({
        value: objeto.value,
        label: objeto.label,
      }))
      .filter((objeto) =>
        objeto.label?.toLocaleLowerCase().includes(query.toLocaleLowerCase())
      );

    setOptionsSubRetail(objetosFiltradosConValueLabel);
  };

  const handleDeleteCampaigns = () => {
    visualExecutionService
      .deleteCampaigns(formExecutionManagementDelete)
      .then((r) => {
        switch (r) {
          case 0: {
            setOpenMessageError(true);
            setDeleteModal(false);
            break;
          }
          case 1: {
            setDeleteModal(false);
            setOpenMessageDeleteOk(true);
            break;
          }
          default: {
            setOpenMessageError(true);
            setDeleteModal(false);
          }
        }
      });
  };

  const handleOnClickMessage = () => {
    setOpenMessageDeleteOk(false);
    setOpenMessageUpdate(false);
    setOpenMessageError(false);
    setOpenMessageCreateOk(false);
    getExecution();
  };

  const handleCampaignsStartDate = (date?: MomentObj | DateRange) => {
    if (!date || moment.isMoment(date)) {
      const newDate = date || undefined;
      if (
        valueCampaignsEndDate &&
        newDate &&
        newDate.isAfter(valueCampaignsEndDate)
      ) {
        setValueCampaignsStartDate(newDate);
        setValueCampaignsEndDate(undefined);
        setFormExecutionManagement((prevState) => ({
          ...prevState,
          startDate: FormatDate(newDate.toString()),
          endDate: "",
        }));
        setHandleValidate((prevState) => ({
          ...prevState,
          StartDate: true,
          EndDate: false,
        }));
      } else {
        setValueCampaignsStartDate(newDate);
        setDisabledDatePickerEnd(false);
        if (newDate !== undefined) {
          setFormExecutionManagement((prevState) => ({
            ...prevState,
            startDate: FormatDate(newDate.toString()),
          }));
          setHandleValidate((prevState) => ({
            ...prevState,
            StartDate: true,
          }));
        }
      }
    }
  };

  const handleCampaignsStartDateEdit = (date?: MomentObj | DateRange) => {
    if (!date || moment.isMoment(date)) {
      const newDate = date || undefined;
      if (
        valueCampaignsEndDateEdit &&
        newDate &&
        newDate.isAfter(valueCampaignsEndDateEdit)
      ) {
        setValueCampaignsStartDateEdit(newDate);
        setValueCampaignsEndDateEdit(undefined);
        setHandleValidateEdit((prevState) => ({
          ...prevState,
          StartDate: true,
          EndDate: false,
        }));
        setFormExecutionManagementEdit((prevState) => ({
          ...prevState,
          StartDate: FormatDate(newDate.toString()),
          EndDate: "",
        }));
      } else {
        setValueCampaignsStartDateEdit(newDate);
        setHandleValidateEdit((prevState) => ({
          ...prevState,
          StartDate: true,
        }));
        if (newDate !== undefined) {
          setFormExecutionManagementEdit((prevState) => ({
            ...prevState,
            StartDate: FormatDate(newDate.toString()),
          }));
        }
      }
    }
  };

  const handleCampaignsEndDate = (date?: MomentObj | DateRange) => {
    if (!date || moment.isMoment(date)) {
      const newDate = date || undefined;
      if (valueCampaignsStartDate !== undefined && newDate !== undefined) {
        if (valueCampaignsStartDate > newDate) {
          setValueCampaignsEndDate(undefined);
          setFormExecutionManagement((prevState) => ({
            ...prevState,
            endDate: "",
          }));
          setHandleValidate((prevState) => ({
            ...prevState,
            EndDate: false,
          }));
        } else {
          setValueCampaignsEndDate(newDate);
          setFormExecutionManagement((prevState) => ({
            ...prevState,
            endDate: FormatDate(newDate.toString()),
          }));
          setHandleValidate((prevState) => ({
            ...prevState,
            EndDate: true,
          }));
        }
      }
    }
  };

  const handleCampaignsEndDateEdit = (date?: MomentObj | DateRange) => {
    if (!date || moment.isMoment(date)) {
      const newDate = date || undefined;
      if (valueCampaignsStartDateEdit !== undefined && newDate !== undefined) {
        if (valueCampaignsStartDateEdit > newDate) {
          setValueCampaignsEndDateEdit(undefined);
          setHandleValidateEdit((prevState) => ({
            ...prevState,
            EndDate: false,
          }));
          setFormExecutionManagementEdit((prevState) => ({
            ...prevState,
            EndDate: "",
          }));
        } else {
          setValueCampaignsEndDateEdit(newDate);
          setHandleValidateEdit((prevState) => ({
            ...prevState,
            EndDate: true,
          }));
          setFormExecutionManagementEdit((prevState) => ({
            ...prevState,
            EndDate: FormatDate(newDate.toString()),
          }));
        }
      }
    }
  };

  const isEndDateOutsideRange = (day: MomentObj) => {
    return valueCampaignsStartDate
      ? day.isBefore(valueCampaignsStartDate, "day")
      : false;
  };

  const isEndDateOutsideRangeEdit = (day: MomentObj) => {
    return valueCampaignsStartDateEdit
      ? day.isBefore(valueCampaignsStartDateEdit, "day")
      : false;
  };

  const onClickEdit = () => {    
    visualExecutionService
      .updateCampaigns(formExecutionManagementEdit)
      .then((r) => {
        switch (r) {
          case 0: {
            setOpenMessageError(true);
            setEditModal(false);
            break;
          }
          case 1: {
            setEditModal(false);
            setOpenMessageUpdate(true);
            break;
          }
          default: {
            setOpenMessageError(true);
            setEditModal(false);
          }
        }
      });
  };

  const onClickCreate = () => {
    if (formExecutionManagement.countryIDs === "") {
      const countryIDsString = optionsCountry.map(option => option.value).join(",");
      
      setFormExecutionManagement((prevState) => ({
        ...prevState,
        countryIDs: countryIDsString,
      }));

    }
    
    visualExecutionService
      .createCampaigns(formExecutionManagement)
      .then((r) => {
        switch (r) {
          case 0: {
            setOpenMessageError(true);
            setOpenModalCreateExecution(false);
            break;
          }
          case 1: {
            setOpenModalCreateExecution(false);
            setOpenMessageCreateOk(true);
            break;
          }
          default: {
            setOpenMessageError(true);
            setOpenModalCreateExecution(false);
          }
        }
      });
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    files: FileList | [],
    inputValue: string
  ) => {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append("formFile", files[0]);

      const folderName = "pdf";
      const currentDate = moment().format("YYYY-MM-DD");

      try {
        const response = await productService.postImage(
          formData,
          folderName,
          moment(currentDate).format("YYYY-MM-DD")
        );
        setFormExecutionManagement((prevState) => ({
          ...prevState,
          url: response.path,
        }));
        setHandleValidate((prevState) => ({
          ...prevState,
          Url: true,
        }));
      } catch (error) {
        console.error("Error al subir el archivo", error);
      }
    }
  };

  const onClearFilePicker = () => {
    setHandleValidate((prevState) => ({
      ...prevState,
      Url: false,
    }));
    setFormExecutionManagement((prevState) => ({
      ...prevState,
      url: "",
    }));
  };

  return (
    <>
      <div style={{ padding: "1%" }}>
        <h4>{t("header.executionManagement")}</h4>

        <Button style={{ margin: "5px" }} onClick={handleOnClickOpenCreate}>
          {t("modal.createExecution")}
        </Button>

        <div style={{ padding: "20px" }}>
          <Card
            appearance="outlined"
            className="divTableExecution"
            content={
              <Table
                className="tableExecution"
                behavior={{
                  type: "singlePage",
                }}
                columnResize
                loading={loading}
                columns={columns}
                data={pagedData}
                loadingDataLength={5}
                preferences={tablePreferences}
                pagination={paginationProps}
              />
            }
          />
        </div>

          <Modal
            className="customModalWidthExecution"
            align="start"
            id="modal-id"
            show={openModalCreateExecution}
            onClose={handleOnClickCloseCreate}
            footer={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Group>
                  <Button disabled={isButtonValid} onClick={onClickCreate}>
                    {t("header.save")}
                  </Button>
                  <Button
                    appearance="secondary"
                    onClick={handleOnClickCloseCreate}
                  >
                    {t("header.cancel")}
                  </Button>
                </Group>
              </div>
            }
            title={t("header.execution")}
          >
            <div className="modal-contentExecution">
              <div className="rowExecution">
                <TextBox
                id="name"
                  label={t("header.name")}
                  placeholder={t("header.name")}
                  onChange={changeHandlerName}
                  value={valueName}
                  required={isNameValid}
                />
                <DatePicker
                  className="customDatePickerExecution"
                  blockPastDates
                  calendarOrientation={["right", "down"]}
                  label="Start Date"
                  onChange={handleCampaignsStartDate}
                  orientation="horizontal"
                  value={valueCampaignsStartDate}
                  format="LL"
                  clearIcon={false}
                />
                <DatePicker
                  className="customDatePickerExecution"
                  clearIcon={false}
                  calendarOrientation={["right", "down"]}
                  label="End Date"
                  onChange={handleCampaignsEndDate}
                  orientation="horizontal"
                  value={valueCampaignsEndDate}
                  format="LL"
                  disabled={disabledDatePickerEnd}
                  isOutsideRange={isEndDateOutsideRange}
                />
              </div>

              <div className="rowExecution">
                <Select
                  className="selectCountry"
                  options={optionsCountry}
                  id="selectCountry"
                  label={t("header.country")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={onChangeCountry}
                  value={valueCountry}
                  onClear={onClearCountrySelect}
                  multiple
                />
                <Select
                  className="selectSubRetail"
                  options={optionsSubRetail}
                  id="selectSubRetail"
                  label={t("header.subRetail")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={onChangeSubRetail}
                  value={valueSubRetail}
                  onClear={onClearSubRetailSelect}
                  onSearch={handleSearchSubRetail}
                  searchDelay={500}
                  showSearch={true}
                  multiple
                  disabled={isDisabledCountry}
                />
              </div>

              <div className="file-upload-container">
                <FilePicker
                  key={openModalCreateExecution ? "open" : "closed"}
                  id="file-picker"
                  accept=".pdf"
                  onChange={handleFileChange}
                  onClear={onClearFilePicker}
                />
              </div>
            </div>
          </Modal>
        
          <Modal
            className="customModalWidth"
            align="start"
            id="modal-edit"
            show={editModal}
            onClose={handleOnClickCloseEdit}
            footer={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Group>
                  <Button disabled={isButtonValidEdit} onClick={onClickEdit}>
                    {t("header.save")}
                  </Button>
                  <Button
                    appearance="secondary"
                    onClick={handleOnClickCloseEdit}
                  >
                    {t("header.cancel")}
                  </Button>
                </Group>
              </div>
            }
            title={t("header.execution")}
          >
            <div className="modal-contentExecution">
              <div className="rowExecution">
                <TextBox
                  id="nameEdit"
                  label={t("header.name")}
                  placeholder={t("header.name")}
                  onChange={changeHandlerNameEdit}
                  value={valueNameEdit}
                  required={isNameValidEdit}
                />
                <DatePicker
                  className="customDatePickerExecution"
                  blockPastDates
                  calendarOrientation={["right", "down"]}
                  label="Start Date"
                  onChange={handleCampaignsStartDateEdit}
                  orientation="horizontal"
                  value={valueCampaignsStartDateEdit}
                  format="LL"
                  clearIcon={false}
                />
                <DatePicker
                  className="customDatePickerExecution"
                  clearIcon={false}
                  calendarOrientation={["right", "down"]}
                  label="End Date"
                  onChange={handleCampaignsEndDateEdit}
                  orientation="horizontal"
                  value={valueCampaignsEndDateEdit}
                  format="LL"
                  isOutsideRange={isEndDateOutsideRangeEdit}
                />
              </div>

              <div className="rowExecution">
                <Select
                  className="selectSubRetail"
                  options={optionsSubRetail}
                  id="selectSubRetailEdit"
                  label={t("header.subRetail")}
                  placement="bottom"
                  helperTextVisibility="auto"
                  onChange={onChangeSubRetailEdit}
                  value={valueSubRetailEdit}
                  onClear={onClearSubRetailSelectEdit}
                  onSearch={handleSearchSubRetail}
                  searchDelay={500}
                  showSearch={true}
                  multiple
                />
              </div>
            </div>
          </Modal>
        

        <ModalInformational
          idKey="modal-DeleteOk"
          setOpenCloseModal={() => setOpenMessageDeleteOk(false)}
          openModal={openMessageDeleteOk}
          titleMessage={t("modal.message")}
          message={t("modal.deleteCampaigns")}
          onClickOk={handleOnClickMessage}
        />

        <ModalInformational
          idKey="modal-CreateOk"
          setOpenCloseModal={() => setOpenMessageCreateOk(false)}
          openModal={openMessageCreateOk}
          titleMessage={t("modal.message")}
          message={t("modal.createCampaigns")}
          onClickOk={handleOnClickMessage}
        />

        <ModalInformational
          idKey="modal-Error"
          setOpenCloseModal={() => setOpenMessageError(false)}
          openModal={openMessageError}
          titleMessage={t("modal.message")}
          message={t("modal.generalError")}
          onClickOk={handleOnClickMessage}
        />

        <ModalInformational
          idKey="modal-UpdateOk"
          setOpenCloseModal={() => setOpenMessageUpdate(false)}
          openModal={openMessageUpdate}
          titleMessage={t("modal.message")}
          message={t("modal.updateInfo")}
          onClickOk={handleOnClickMessage}
        />

        <ModalQuestion
          id="modal-delete"
          setOpenCloseModal={() => setDeleteModal(false)}
          openModal={deleteModal}
          titleMessage={t("modal.warningTitle")}
          message={t("modal.messageDeleteCampaignsBySubretail")}
          onClickYes={handleDeleteCampaigns}
          onClickNo={() => setDeleteModal(false)}
          titleButtonYes={t("header.delete")}
          titleButtonNo={t("header.cancel")}
        />
      </div>
    </>
  );
}
